import { createErrorOperationResult } from '@hc-frontend/core-utils-business-operation';

import { TrackImpressionOptions } from '../../entities/tracking-options';
import type {
  SemContentRepository,
  TrackImpressionResult,
} from '../../repositories/sem-content-repository';

export type TrackImpressionUseCase = (
  options: TrackImpressionOptions,
) => Promise<TrackImpressionResult>;

export const trackImpressionFactory =
  (
    provider: Pick<SemContentRepository, 'trackImpression'>,
  ): TrackImpressionUseCase =>
  async (options) => {
    const parsedOptions = TrackImpressionOptions.safeParse(options);

    if (!parsedOptions.success) {
      return createErrorOperationResult({
        errors: [
          {
            code: 'failedToTrackImpression',
            rootCause: parsedOptions.error,
          },
        ],
      });
    }
    return provider.trackImpression(options);
  };
